import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { OptionToPurchaseTableI } from 'src/app/shared/models/app-models';

@Component({
  selector: 'app-option-purchase-table',
  templateUrl: './option-purchase-table.component.html',
  styleUrls: ['./option-purchase-table.component.scss'],
})
export class OptionPurchaseTableComponent implements OnInit, OnChanges {
  @Input() dataTb: OptionToPurchaseTableI[] = [];
  columnsToDisplay = [
    'displayItemNumber',
    'Description',
    'Quantity',
    'CurrencyCode',
    'EstimatedUnitPrice',
    'UnitOfMeasurements',
    'DurationYears',
    'DurationMonths',
  ];
  pageSizeOptions: number[] = [5, 10, 20];
  tableData: OptionToPurchaseTableI[] = [];
  dataSource = new MatTableDataSource<OptionToPurchaseTableI>(this.tableData);

  ngOnInit(): void {
    this.dataSource.data = this.customDataTb(this.dataTb);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['dataTb'] && changes['dataTb'].currentValue) {
      this.dataSource.data = this.customDataTb(changes['dataTb'].currentValue);
    }
  }

  fillMissingNumbers(sequence: number[]) {
    if (!sequence?.length) return [];

    const filledSequence = [];

    for (let i = Math.min(...sequence); i <= Math.max(...sequence); i+=1) {
      filledSequence.push(i)
    }

    return filledSequence;
  }

  customDataTb(data: OptionToPurchaseTableI[]) {
    const purchaseItemIdsSequence = this.fillMissingNumbers(
      data.map((item) => item.PurchaseItemId as number).filter(Boolean)
    );

    return data?.map((item: OptionToPurchaseTableI, index: number) => {

      const itemNo = purchaseItemIdsSequence.findIndex(i => i === item.PurchaseItemId)

      return { ...item, index: itemNo + 1, displayItemNumber: item.PurchaseItem?.ItemNumber ?? (itemNo + 1), DurationMonths: item.DurationMonths || 0 };
    });
  }
}
